import React, { Component } from "react";
import { Loading } from "../../../../common/loading";
import Comment from "../../../../common/comments/comment.component";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryEquipmentActions } from "../../../../../store/external/inventory/equipment.reducer";
import { MAX_LENGTH } from "../../../../../../app/constants/external-constants";

class EquipmentComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }

    }
    componentDidMount() {
        const { getInventoryEquipmentComments } = this.props;
        getInventoryEquipmentComments(this.props.equipmentId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }


    async postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postInventoryEquipmentComments, getInventoryEquipmentComments } = this.props;
       await postInventoryEquipmentComments(this.props.equipmentId, attachedFilename, attachedFileData, commentDescription);
       await getInventoryEquipmentComments(this.props.equipmentId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }


    handleDeleteEquipmentComments = async (equipmentId) => {
        this.setState({ isLoading: true });
        const { deleteInventoryEquipmentComments, getInventoryEquipmentComments } = this.props;
        await deleteInventoryEquipmentComments(equipmentId, this.props.equipmentId);
        await getInventoryEquipmentComments(this.props.equipmentId).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }
    render() {
        if (this.state.isLoading) {
            return <Loading />
        }
        const { inventoryEquipmentComments } = this.props.inventoryEquipment
        return (

            <Comment
                commentList={inventoryEquipmentComments}
                addCommentAction={this.postComment.bind(this)}
                deleteCommentAction={this.handleDeleteEquipmentComments.bind(this)}
                maxLength={MAX_LENGTH.limit_500}
                isEquipment={true}
                
                //Access Type
                isReadOnly={this.props.isReadOnly}
                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                isReadAndWrite={this.props.isReadAndWrite}
            />
        )
    }
}
export default connect(
    state => {
        const { inventoryEquipment } = state;
        const { inventoryEquipmentFormA } = state.form;

        return {
            inventoryEquipment,
            inventoryEquipmentFormA
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryEquipmentActions),
        dispatch
    )
)(EquipmentComment);